import React from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

import Header from './Header';
import Footer from './Footer';

export default function Blog2() {

  const pdfUrl = 'assets/cv/presentation.pptx.pdf'

  return (
    <div>
    <Header className="header-inner-pages" />

  <main id="main">

    <div className="main-content paddsection">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-10 col-md-offset-2">
            <div className="row">
              <div className="container-main single-main">
                <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                  <div style={{ height: '750px', border: '1px solid rgba(0, 0, 0, 0.3' }}>
                    <Viewer fileUrl={pdfUrl} />
                  </div>
                </Worker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </main>

  <Footer />

  <a href="/GoogleDev" className="back-to-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>

</div>

  )
}
